export default {
  install(Vue) {
    Vue.filter('label', value => value?.label || '');
  },
};
